export const IrelandBasedCompanies = [
  'H & M SERVICES',
  'SAMSUNG MOBILE (WALK IN)',
  'AV SERVICE CENTRE',
];
